<template>
  <Card :header="metrics">
    <template #card-body>
      <div class="metrics-Container">
        <div
          v-for="data in InfoStatData"
          :key="data.key"
          class="stats-container"
          @click="handleCardClick(data.redirectPath)"
        >
          <InfoStats
            :textLabel="data.textLabel"
            :textValue="data.textValue"
            :iconName="data.icon"
            :iconStyle="{ fill: '#f59600' }"
            iconHeight="2.5rem"
            iconWidth="2.5rem"
            :loading="loading"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/rex-components/rex-card.vue';
import InfoStats from '@/rex-components/rex-info-stats.vue';
import graphQl from '@/services/graphQl';
import { mapGetters } from 'vuex';

export default {
  components: { Card, InfoStats },
  data() {
    return {
      metrics: this.$t('total-application-servers'),
      loading: true,
    };
  },
  watch: {
    getDurationTime() {
      this.getData();
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    InfoStatData() {
      return [
        {
          key: 'APM',
          textLabel: this.$t('usage.APM'),
          textValue: '',
          icon: 'apm',
          redirectPath: '/apm',
        },
        {
          key: 'Browser Monitoring',
          textLabel: this.$t('browserMonitoring'),
          textValue: '',
          icon: 'browser',
          redirectPath: '/browser',
        },
        {
          key: 'Database Monitoring',
          textLabel: this.$t('databaseMonitoring'),
          textValue: '',
          icon: 'database',
          redirectPath: '/database',
        },
        {
          key: 'VM Monitoring',
          textLabel: this.$t('vmMonitoring'),
          textValue: '',
          icon: 'vm',
          redirectPath: '/vm',
        },
        {
          key: 'Mobile Monitoring',
          textLabel: this.$t('mobileMonitoring'),
          textValue: '',
          icon: 'mobile',
          redirectPath: '/mobile',
        },
      ];
    },
  },
  methods: {
    async getData() {
      try {
        const params = {
          serviceReq: {
            capability: '',
          },
        };

        const map = {
          A: this.InfoStatData[0],
          B: this.InfoStatData[1],
          D: this.InfoStatData[2],
          V: this.InfoStatData[3],
          M: this.InfoStatData[4],
        };

        const {
          data: {
            data: {
              getApplicationOverview: { capabilityAppCountList },
            },
          },
        } = await graphQl.query('queryGetApplicationByCap').params(params);

        if (capabilityAppCountList && Array.isArray(capabilityAppCountList)) {
          capabilityAppCountList.forEach((ele) => {
            if (map[ele.type]) map[ele.type].textValue = ele.count + '';
          });
        }
        this.loading = false;
      } catch (error) {
        console.log('error', error);
        this.loading = false;
      }
    },
    handleCardClick(redirectPath) {
      this.$router.push(redirectPath);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
.metrics-Container,
.stats-container {
  display: flex;
  animation: expand 2s;
  cursor: pointer;
}
.stats-container {
  flex: 1;
}
.metrics-Container {
  gap: 1rem;
}
@keyframes expand {
  0% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
</style>
